import { useTranslation } from 'react-i18next';

import { cn } from '@/lib/utils';

import styles from './EmptyResults.module.scss';

type Props = {
  message?: string;
  subMessage?: string;
  isAuditLogs?: boolean;
  size?: 'small' | 'medium';
};

const EmptyResults = ({ message, subMessage, isAuditLogs = false, size }: Props) => {
  const { t } = useTranslation();
  return (
    <div
      className={cn(styles.emptyWrapper, [styles[size]], {
        [styles['emptyWrapper--auditLogs']]: isAuditLogs,
      })}
    >
      <svg
        width="97"
        height="106"
        viewBox="0 0 97 106"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#a1)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M71.307 61.092c5.409 0 10.308 2.2 13.862 5.736a19.501 19.501 0 0 1 5.737 13.862c0 3.951-1.182 7.643-3.192 10.723l8.48 9.239L90.345 106l-8.177-8.997a19.506 19.506 0 0 1-10.852 3.278c-5.41 0-10.309-2.2-13.854-5.737a19.496 19.496 0 0 1-5.737-13.854c0-5.408 2.2-10.308 5.737-13.862a19.445 19.445 0 0 1 13.845-5.736ZM5.721 35.247v40.621c0 .233.086.449.233.596a.833.833 0 0 0 .595.241h36.688c2.527.259 2.605 4.632 0 5.012h-23.48v9.316c0 .242.085.449.24.596a.827.827 0 0 0 .596.233h22.653c1.828.207 2.424 4.364 0 5.011H20.619a5.744 5.744 0 0 1-4.124-1.725 5.804 5.804 0 0 1-1.725-4.123v-9.317H6.575a5.744 5.744 0 0 1-4.123-1.725A5.804 5.804 0 0 1 .727 75.86V5.849C.735 4.244 1.39 2.76 2.46 1.725A5.804 5.804 0 0 1 6.584 0h61.523c1.604 0 3.088.656 4.123 1.717a5.812 5.812 0 0 1 1.717 4.123v9.316h8.195c1.604 0 3.088.656 4.123 1.717a5.82 5.82 0 0 1 1.725 4.123V52.94c-.172 1.828-4.667 1.854-5.046 0V21.014a.826.826 0 0 0-.233-.595.832.832 0 0 0-.595-.242H73.92v32.771c-.44 1.657-4.175 1.907-5.012 0v-17.7H5.72Zm0-4.615H68.91V5.849a.799.799 0 0 0-.242-.596.833.833 0 0 0-.595-.241H6.55a.799.799 0 0 0-.595.241.827.827 0 0 0-.233.596v24.783Zm28.622-12.05h4.072c.215 0 .362.146.362.361v9.023a.344.344 0 0 1-.362.363h-4.072a.344.344 0 0 1-.362-.363v-9.023c0-.138.147-.362.362-.362Zm20.065 0h4.072c.215 0 .362.146.362.361v9.023a.344.344 0 0 1-.362.363h-4.072a.344.344 0 0 1-.362-.363v-9.023c0-.138.146-.362.362-.362Zm-10.032-7.635h4.071c.225 0 .363.146.363.362v16.727a.344.344 0 0 1-.363.362h-4.071a.344.344 0 0 1-.363-.363V11.31c0-.216.147-.362.363-.362Zm-30.089 2.76h4.072c.215 0 .362.147.362.362v13.966a.344.344 0 0 1-.362.363h-4.072a.344.344 0 0 1-.362-.363V14.078c-.07-.224.146-.37.362-.37Zm10.024-2.76h4.072c.215 0 .362.146.362.362v16.727a.344.344 0 0 1-.363.362h-4.071a.344.344 0 0 1-.362-.363V11.31c0-.216.146-.362.362-.362Zm13.25 47.005 11.343.198c0 4.072-2 7.807-5.34 10.075l-6.003-10.273Zm-.621-3.468-.13-13.216v-.871l.872.069c1.07.069 2.139.267 3.14.535 1 .267 1.932.664 2.872 1.13 4.607 2.407 7.807 7.211 8.074 12.68l.07.872h-.872l-13.146-.397h-.734l-.146-.802Zm1.466-12.422.13 11.62 11.55.336c-.466-4.538-3.27-8.48-7.142-10.541a16.177 16.177 0 0 0-2.536-1.01c-.734-.138-1.337-.267-2.002-.405Zm-4.65 14.708 6.479 11.214a13.018 13.018 0 0 1-6.478 1.734c-7.143 0-12.948-5.806-12.948-12.957 0-6.944 5.477-12.68 12.413-12.948l.535 12.957ZM81.729 70.26a14.695 14.695 0 0 0-10.421-4.322 14.71 14.71 0 0 0-10.42 4.322 14.695 14.695 0 0 0-4.322 10.42 14.71 14.71 0 0 0 4.321 10.421 14.695 14.695 0 0 0 10.421 4.322 14.71 14.71 0 0 0 10.42-4.322 14.71 14.71 0 0 0 4.322-10.42 14.71 14.71 0 0 0-4.322-10.42Z"
            fill="var(--muted)"
          />
        </g>
        <defs>
          <clipPath id="a1">
            <path fill="#fff" transform="translate(.734)" d="M0 0h95.459v106H0z" />
          </clipPath>
        </defs>
      </svg>

      <p className={styles.emptyMessage}>
        <span className="text-base leading-6 font-semibold">
          {message || t('analytics.no_data')}
        </span>
      </p>
      {size !== 'small' && (
        <p className={styles.emptySubMessage}>
          <span className="text-sm leading-5 font-normal">
            {subMessage || t('analytics.try_different')}
          </span>
        </p>
      )}
    </div>
  );
};

export default EmptyResults;
